export const GET_ADVOCATES_LIST = "GET_ADVOCATES_LIST";   
export const GET_ADVOCATES_LIST_SUCCESS = "GET_ADVOCATES_LIST_SUCCESS";
export const GET_ADVOCATES_LIST_FAILED = "GET_ADVOCATES_LIST_FAILED";

export const ADD_ADVOCATE = "ADD_ADVOCATE";
export const ADD_ADVOCATE_SUCCESS = "ADD_ADVOCATE_SUCCESS";
export const ADD_ADVOCATE_FAILED = "ADD_ADVOCATE_FAILED";

export const UPDATE_ADVOCATE = "UPDATE_ADVOCATE";
export const UPDATE_ADVOCATE_SUCCESS = "UPDATE_ADVOCATE_SUCCESS";
export const UPDATE_ADVOCATE_FAILED = "UPDATE_ADVOCATE_FAILED";

export const UPDATE_ADVOCATE_STATUS = "UPDATE_ADVOCATE_STATUS";
export const UPDATE_ADVOCATE_STATUS_SUCCESS = "UPDATE_ADVOCATE_STATUS_SUCCESS";
export const UPDATE_ADVOCATE_STATUS_FAILED = "UPDATE_ADVOCATE_STATUS_FAILED";

export const UPLOAD_ADVOCATE_DOC = "UPLOAD_ADVOCATE_DOC";
export const UPLOAD_ADVOCATE_DOC_SUCCESS = "UPLOAD_ADVOCATE_DOC_SUCCESS";
export const UPLOAD_ADVOCATE_DOC_FAILED = "UPLOAD_ADVOCATE_DOC_FAILED";

export const DOWNLOAD_CONTRACT = "DOWNLOAD_CONTRACT";
export const DOWNLOAD_CONTRACT_SUCCESS = "DOWNLOAD_CONTRACT_SUCCESS";
export const DOWNLOAD_CONTRACT_FAILED = "DOWNLOAD_CONTRACT_FAILED";

export const VIEW_CONTRACT = "VIEW_CONTRACT";
export const VIEW_CONTRACT_SUCCESS = "VIEW_CONTRACT_SUCCESS";
export const VIEW_CONTRACT_FAILED = "VIEW_CONTRACT_FAILED";

export const SEND_CONTRACT = "SEND_CONTRACT";
export const SEND_CONTRACT_SUCCESS = "SEND_CONTRACT_SUCCESS";
export const SEND_CONTRACT_FAILED = "SEND_CONTRACT_FAILED";

export const CLEAR_ADVOCATE_MESSAGES = "CLEAR_ADVOCATE_MESSAGES";